




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import extendCascader from "@/components/pages/ProductCreate/extendCascader.vue";
import selectChannelInfo from "@/components/pages/ProductCreate/selectChannelInfo.vue";
import category from "@/views/Category.vue";
const productCreate = namespace("productCreate");
@Component({ components: { selectChannelInfo } })
export default class selectChannelCategory extends Vue {
  @Prop({ default: () => [] }) disabledShop;
  visible = false;

  async handleSubmit() {
    let res = await (this.$refs.selectChannelInfo as any).submit();
  }

  async addChannel(data) {
    let { value, label } = data;
    let info: any = this.$t("20200917.Product.page_refresh");
    let confirmButtonText: any = this.$t("20200917.Product.switch");
    let cancelButtonText: any = this.$t("Basic.Cancel");
    this.$confirm(info, {
      confirmButtonText,
      cancelButtonText,
      type: "warning"
    })
      .then(() => {
        this.$emit("addChannel", {
          value,
          label
        });
        this.visible = false;
      })
      .catch(() => {
        // this.visible = false;
      });
  }
}
